import { createFileRoute } from "@tanstack/react-router";

import BillingSettingsPage from "@/admin/settings/billing/page";

export const Route = createFileRoute("/app/$storeId/settings/billing")({
    component: RouteComponent,
});

function RouteComponent() {
    return <BillingSettingsPage />;
}
